import StageWarning from './container';

export default StageWarning;
